import React from 'react';
import { Navigate } from 'react-router-dom';
import useMajeeRights from '../../hooks/useMajeeRights';

/**
 * Guard a route by consultation section and/or news edition.
 * @param {string} [section] - SECTIONS key for canConsult
 * @param {boolean} [editNews] - require canEditNews
 */
export default function RequireRight({
  section, editNews = false, children,
}) {
  const rights = useMajeeRights();

  if (editNews && !rights.canEditNews) {
    return <Navigate to="/majee/actus" replace />;
  }
  if (section && !rights.canConsult(section)) {
    return <Navigate to="/majee/home" replace />;
  }
  return children;
}
